// extracted by mini-css-extract-plugin
module.exports = {"makeOfferButton":"AUGkvJrc","passButton":"_1Cm2nkT3"};
    if(module.hot) {
      // 1754514979636
      var cssReload = require("!../../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  